import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectAll"]

  connect() {
    // Set initial state
    this.updateSelectAllState()

    // Listen for dynamic changes to child checkboxes
    this.observeChildren()
  }

  toggle(event) {
    const selectAllCheckbox = event.currentTarget
    const isChecked = selectAllCheckbox.checked

    const wrapper = selectAllCheckbox.closest(".form-check").parentElement
    const checkboxes = wrapper.querySelectorAll(
      'input[type="checkbox"][name^="advance_search_member_profiles_form"]:not([data-select-all-target])',
    )

    checkboxes.forEach((checkbox) => {
      checkbox.checked = isChecked
      // Trigger input/change for other controllers
      checkbox.dispatchEvent(new Event("input", { bubbles: true }))
    })

    this.updateSelectAllState()
  }

  updateSelectAllState(event = null) {
    const wrapper = event
      ? event.currentTarget.closest(".form-check").parentElement
      : null

    const targets = wrapper
      ? [wrapper.querySelector("[data-select-all-target]")]
      : this.selectAllTargets

    targets.forEach((selectAllCheckbox) => {
      if (!selectAllCheckbox) return

      const wrapperElement =
        selectAllCheckbox.closest(".form-check").parentElement
      const checkboxes = wrapperElement.querySelectorAll(
        'input[type="checkbox"][name^="advance_search_member_profiles_form"]:not([data-select-all-target])',
      )

      if (checkboxes.length === 0) {
        // No children → uncheck and disable Select All
        selectAllCheckbox.checked = false
        selectAllCheckbox.disabled = true
      } else {
        // Enable Select All if there are children
        selectAllCheckbox.disabled = false
        // If all children checked → Select All is checked
        selectAllCheckbox.checked = Array.from(checkboxes).every(
          (cb) => cb.checked,
        )
      }
    })
  }

  observeChildren() {
    this.selectAllTargets.forEach((selectAllCheckbox) => {
      const wrapper = selectAllCheckbox.closest(".form-check").parentElement

      // Attach change listeners to current children
      this.attachChildListeners(wrapper)

      // Observe dynamically added/removed child checkboxes
      const observer = new MutationObserver(() => {
        this.attachChildListeners(wrapper)
        this.updateSelectAllState()
      })

      observer.observe(wrapper, { childList: true, subtree: true })
    })
  }

  attachChildListeners(wrapper) {
    const checkboxes = wrapper.querySelectorAll(
      'input[type="checkbox"][name^="advance_search_member_profiles_form"]:not([data-select-all-target])',
    )

    checkboxes.forEach((checkbox) => {
      if (!checkbox.dataset.listenerAttached) {
        checkbox.addEventListener("change", () => this.updateSelectAllState())
        checkbox.dataset.listenerAttached = "true"
      }
    })
  }
}
